module.exports = __webpack_public_path__ + "img/bg-pot-0.6f107f63.png";